import React, { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { SectionHeading } from "../components/Section";

// Song slots for the "Hear the Band" page.
// The user will upload their own MP3s and I'll wire them into `src` below.
const TRACKS = [
  {
    title: "Private Eyes",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_oates-hall-legacy/artifacts/0gpnfkkm_Private%20Eyes%20-%20Teaser.mp3",
  },
  {
    title: "Kiss on My List",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_oates-hall-legacy/artifacts/5s0t5fe1_Kiss%20On%20My%20List%20-%20Teaser.mp3",
  },
  {
    title: "She's Gone",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_oates-hall-legacy/artifacts/89edor6q_She%27s%20Gone%20-%20Teaser.mp3",
  },
  {
    title: "Maneater",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_oates-hall-legacy/artifacts/4gjfwycy_Maneater%20-%20wSax%20-%20Teaser.mp3",
  },
];

function TrackCard({ track, index }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const a = audioRef.current;
    if (!a || !track.src) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.currentTime = 0;
      a.play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    }
  };

  return (
    <div
      className="neon-card p-6 flex items-center gap-5"
      data-testid={`music-track-${index}`}
    >
      <button
        type="button"
        onClick={toggle}
        disabled={!track.src}
        aria-label={playing ? "Pause" : "Play"}
        data-testid={`music-track-toggle-${index}`}
        className="flex items-center justify-center w-14 h-14 rounded-full transition-transform hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed"
        style={{
          background: "radial-gradient(circle, #ff00ff 0%, #8a2be2 100%)",
          boxShadow: "0 0 18px rgba(255,0,255,0.55)",
        }}
      >
        {playing ? (
          <Pause size={22} className="text-white" fill="currentColor" />
        ) : (
          <Play
            size={22}
            className="text-white translate-x-[1px]"
            fill="currentColor"
          />
        )}
      </button>

      <div className="flex-1 min-w-0">
        <div className="font-display text-lg md:text-xl uppercase text-white truncate">
          {track.title}
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-cyan-300 mt-1">
          {track.src ? "Ready to play" : "Awaiting upload"}
        </div>
      </div>

      {track.src && (
        <audio ref={audioRef} src={track.src} preload="none" onEnded={() => setPlaying(false)} />
      )}
    </div>
  );
}

export default function MusicPage() {
  return (
    <section
      id="music"
      data-testid="music-page"
      className="min-h-screen w-full section-pad relative"
      style={{ paddingTop: "9rem" }}
    >
      <div className="container-x">
        <SectionHeading
          theme="synthwave"
          title="Hear // The // Band"
          sub="Four tracks from Out Of Touch — press play on any card to listen."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {TRACKS.map((t, i) => (
            <TrackCard key={i} track={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
